var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    attrs: {
      "id": "body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.Body)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-10 flex flex-row flex-wrap gap-4 sm:flex-col sm:gap-10",
    attrs: {
      "id": "buttons"
    }
  }, [_vm.formFillRetryButton ? _c('button', {
    key: 'form-fill-retry-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('form-fill-retry');
      }
    }
  }, [_vm._v("\n\t\t\t\tVerify Information\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.retryPlaidButton ? _c('button', {
    key: 'retry-plaid-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('retry-plaid');
      }
    }
  }, [_vm._v("\n\t\t\t\tTry another account\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.changePlanButton ? _c('button', {
    key: 'change-plan-button',
    class: _vm.buttonClasses,
    on: {
      "click": function ($event) {
        return _vm.$emit('change-plan');
      }
    }
  }, [_vm._v("\n\t\t\t\tChange plan\n\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('disclosure-footer')], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };